import React from 'react';
import { Typography } from '@mui/material';

const BankAccounts: React.FC = () => {
  return (
    <Typography variant="body1" color="grey.500">
      Coming soon.
    </Typography>
  );
};

export default BankAccounts;
